import React from 'react';
import { FaInstagram, FaGithub } from 'react-icons/fa';
import './Footer.scss';

function Footer() {
  return (
    <footer className="footer">
      <section className="credit-container">
        <div className="tab-one">
          <p>Thanks for visiting :)</p>
        </div>

        <div className="tab-two">
          <p>Visit me on : </p>
          <div>
            <span>
              <a
                href="https://www.instagram.com/finn_ahamed/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
            </span>
            <span>
              <a
                href="https://github.com/Finn-AM"
                target="_blank"
                rel="noreferrer"
              >
                <FaGithub />
              </a>
            </span>
          </div>
        </div>
      </section>
      <p className="last-text">&#169; Designed and Coded by Finn</p>
    </footer>
  );
}

export default Footer;
